/* ══════════════════════════════════════════════════════════════
   COMPLETE THE LOADOUT — Equipment slot bundle
   Reads slot products from a JSON script tag rendered by the
   section, so no Liquid lives in this file.
   Load AFTER brutech-partners.js
══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var ALL_SLOTS = [
    { key: 'mouse',      label: 'MOUSE'      },
    { key: 'keyboard',   label: 'KEYBOARD'   },
    { key: 'headset',    label: 'HEADSET'    },
    { key: 'mousepad',   label: 'PAD'        },
    { key: 'microphone', label: 'MIC'        },
    { key: 'controller', label: 'CONTROLLER' },
    { key: 'webcam',     label: 'WEBCAM'     },
    { key: 'chair',      label: 'CHAIR'      }
  ];

  function money(cents) {
    var v = (cents / 100).toFixed(2);
    return 'R' + v.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }

  function hideSection(root) {
    var section = root.closest('.shopify-section') || root;
    section.style.display = 'none';
  }

  function build(root) {
    var dataEl = root.querySelector('script[data-bundle-products]');
    if (!dataEl) return;

    var items;
    try { items = JSON.parse(dataEl.textContent); }
    catch (e) { console.warn('[Brutech] Bundle JSON:', e); hideSection(root); return; }

    /* No products picked yet. Hide the whole section rather than leaving
       a permanent "LOADING" label on a live page. */
    if (!items || !items.length) { hideSection(root); return; }

    var slots = {};
    /* Group every product by slot rather than taking the first match, so
       the selection mode below has something to choose from. */
    var pool = {};
    items.forEach(function (p) {
      var text = ((p.title || '') + ' ' + (p.type || '') + ' ' + (p.vendor || '')).toLowerCase();
      var cat = window.BrutechPartners
                ? window.BrutechPartners.detectCategory(text)
                : null;
      if (!cat) return;
      (pool[cat] = pool[cat] || []).push(p);
    });

    /* first   fixed, the order they appear in the collection
       random  a different pick on every page view
       daily   stable for the day, changes tomorrow
       Manual product blocks bypass all of this, they are used as given. */
    var mode = root.getAttribute('data-pick') || 'first';
    var seed = 0;
    if (mode === 'daily') {
      var d = new Date();
      seed = d.getFullYear() * 400 + d.getMonth() * 31 + d.getDate();
    }
    Object.keys(pool).forEach(function (cat) {
      var list = pool[cat];
      if (mode === 'random') {
        slots[cat] = list[Math.floor(Math.random() * list.length)];
      } else if (mode === 'daily') {
        /* offset per category so the whole loadout does not rotate in
           lockstep, which would look like one repeating set */
        var off = 0;
        for (var i = 0; i < cat.length; i++) off += cat.charCodeAt(i);
        slots[cat] = list[(seed + off) % list.length];
      } else {
        slots[cat] = list[0];
      }
    });

    /* Adopt brand palette from the first matched product */
    if (window.BrutechPartners && items[0]) {
      var b = window.BrutechPartners.detectBrand(
        ((items[0].vendor || '') + ' ' + (items[0].title || '')).toLowerCase()
      );
      if (b) {
        root.style.setProperty('--bp-ink', b.ink);
        root.style.setProperty('--bp-panel', b.panel);
        root.style.setProperty('--bp-accent', b.accent);
        root.style.setProperty('--bp-accent-rgb', b.accentRgb);
        root.style.setProperty('--bp-edge', b.edge);
        root.style.setProperty('--bp-edge-rgb', b.edgeRgb);
      }
    }

    var grid = root.querySelector('.brutech-slot-grid');
    if (!grid) return;
    grid.innerHTML = '';

    /* Drop the slot the shopper is already looking at. Offering a
       keyboard on a keyboard page wastes the most valuable slot. */
    var skip = root.getAttribute('data-skip-slot');
    var SLOT_ORDER = ALL_SLOTS.filter(function (s) { return s.key !== skip; });

    var total = 0, filled = 0;
    var ids = [];

    SLOT_ORDER.forEach(function (slot) {
      var p = slots[slot.key];

      if (!p) {
        var empty = document.createElement('div');
        empty.className = 'brutech-slot is-empty';
        empty.innerHTML = '<span class="brutech-slot-empty-label">' +
                          slot.label + '<br>SLOT EMPTY</span>';
        grid.appendChild(empty);
        return;
      }

      filled++;
      total += (p.price || 0);
      if (p.variant_id) ids.push(p.variant_id);

      var a = document.createElement('a');
      a.className = 'brutech-slot';
      a.href = p.url || '#';
      a.innerHTML =
        '<div class="brutech-slot-figure">' +
          '<span class="brutech-slot-type">' + slot.label + '</span>' +
          (p.image ? '<img src="' + p.image + '" alt="' + (p.title || '') + '" loading="lazy">' : '') +
        '</div>' +
        '<div class="brutech-slot-body">' +
          '<span class="brutech-slot-name">' + (p.title || '') + '</span>' +
          '<span class="brutech-slot-price">' + money(p.price || 0) + '</span>' +
        '</div>';
      grid.appendChild(a);
    });

    /* One product is not a loadout. Hide rather than show a row of
       empty slots next to a single item. */
    if (filled < 2) { hideSection(root); return; }

    var totalEl = root.querySelector('.brutech-bundle-total-value');
    if (totalEl) totalEl.textContent = money(total);

    var labelEl = root.querySelector('.brutech-bundle-total-label');
    if (labelEl) labelEl.textContent = filled + ' OF ' + SLOT_ORDER.length + ' SLOTS EQUIPPED';

    /* Add all to cart */
    var cta = root.querySelector('.brutech-bundle-cta');
    if (cta && ids.length) {
      cta.addEventListener('click', function () {
        cta.disabled = true;
        cta.textContent = 'EQUIPPING…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: ids.map(function (id) { return { id: id, quantity: 1 }; })
          })
        })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function (e) {
          console.warn('[Brutech] Bundle add:', e);
          cta.disabled = false;
          cta.textContent = 'EQUIP FULL LOADOUT';
        });
      });
    } else if (cta && !ids.length) {
      cta.style.display = 'none';
    }
  }

  function init() {
    document.querySelectorAll('.brutech-loadout-bundle').forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
